<app-loading [show]=isLoad></app-loading>
<section id="home" class="section h-screen overflow-hidden">
    <div class="custom-shape-divider-top-1744242974">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <defs>
                <linearGradient id="myGradient">
                    <stop offset="5%" stop-color="#574698" />
                    <stop offset="95%" stop-color="#f04650" />
                </linearGradient>
            </defs>
            <path
                d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                class="shape-fill"></path>
        </svg>
    </div>
    <div class="flex flex-wrap md:flex-row-reverse h-screen align-items-center image-background_main">
        <div class="w-full md:flex-grow md:w-6" style="z-index: 2;">
            <div class="w-10 md:w-6 mx-auto">
                <form [formGroup]="form">
                    <div class="p-fluid p-3 border-round effectGlass">
                        <div class="text-center">
                            <h2>Recordatorio de Datos</h2>
                            <img src="assets/img/logoSimescco.jpg" class="logo" alt="Logo Simescco Tecnologìa S.A.S">
                        </div>
                        <p>Digite el correo electrónico</p>
                        <div class="p-inputgroup">
                            <div class="p-inputgroup-addon"><i class="pi pi-at"></i></div>
                            <input pInputText type="email" placeholder="Correo electrónico" formControlName="login"
                                pSize="small" class="w-full">
                        </div>
                        <p-divider>
                        </p-divider>
                        <div class="text-center">
                            <button pButton label="Continuar" icon="pi pi-angle-double-right"
                                class="p-button p-button-success" (click)="continuar()"></button>
                        </div>
                        <div class="text-center">
                            <a routerLink="/auth/login" pButton class="p-button p-button-link" label="Regresar al inicio"></a>
                        </div>
                    </div>
                </form>
                <p-toast key="message"></p-toast>
            </div>
        </div>

    </div>
</section>